import React, { useEffect, useState, useContext } from "react";
import "./verifyPhoneNumber.scss";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import vendorsConfig from "../../vendorsConfig";
import Backdrop from "@mui/material/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import { Link, useHistory, Redirect } from "react-router-dom";

import MuiAlert from "@material-ui/lab/Alert";
// axios
import Axios from "axios";

//  cookie functions
import { setCookie } from "../../Functions/cookieFunction";
import { withTranslation, useTranslation, Trans } from "react-i18next";

import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import LoaderAnimation from "../../Components/LoaderAnimation";

// import OTPInput, { ResendOTP } from "otp-input-react";
import OtpInput from "react-otp-input";
import SignupModal from "../signupModal/signupModal";
import { handleError } from "../../Functions/getAlert";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const renderButton = (t) => (buttonProps) => {
  return (
    <button className="createAccountAndforgotPass px-1" {...buttonProps}>
      {buttonProps.remainingTime !== 0 ? (
        <sapn className="text-muted">
          {t("form.send-again")}
          {/* Send again */}
        </sapn>
      ) : (
        <sapn>
          {/* {t("form.send-again")}  */}
          Send again
        </sapn>
      )}
    </button>
  );
};
function VerifyPhoneNumber({
  closeBtn,
  handlePhoneSignup,
  Purpose,
  phone,
  backDrop,
}) {
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  const [OTP, setOTP] = useState("");
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  let history = useHistory();
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [loading, setLoading] = useState(false);
  const [signUpForm, setSignUpForm] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [sendAgain, setSendAgain] = useState(false);
  const [timer, setTimer] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    appDispatch({ type: "setOtpModal", otpModal: false });
  };

  const handleMaxWidthChange = (event) => {
    setMaxWidth(
      // @ts-expect-error autofill of arbitrary value is not handled.
      event.target.value
    );
  };
  const handleFullWidthChange = (event) => {
    setFullWidth(event.target.checked);
  };

  useEffect(() => {
    if (OTP.length == 5) {
      handleCheckOtp();
    }
  }, [OTP]);

  const handleSignUpForm = () => {
    appDispatch({ type: "setOtpModal", otpModal: false });
    appDispatch({ type: "setSignUpModal", signUpModal: true });
  };
  const handleCheckOtp = async () => {
    setLoading(true);
    if (Purpose == "signUp") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}check/otp`,
          { mobile_no: `${phone.phoneCode}${phone.phoneNumber}`, code: OTP }
        );
        if (response.data.success === true) {
          if (response.data.data) {
            handleSignUpForm();
            setOTP("");
          }
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: response.data.data,
          });
        } else if (response.data.success === false) {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: false,
          });
        }
      } catch (e) {
        setLoading(false);
        handleError(e, appDispatch);
      }
    } else if (Purpose == "signIn") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}login/mobile`,
          {
            user_id: appState.fieldValues,
            code: OTP,
          }
        );
        if (response.data.success === true) {
          setLoading(false);
          setOTP("");
          appDispatch({
            type: "login",
            login: response.data.data.id,
            token: response.data.data.token,
          });
          appDispatch({ type: "UpdateProfile", profile: response.data.data });
          appDispatch({
            type: "setAuthToken",
            authToken: response.data.data.token,
          });
          setCookie("tokenAuth", response.data.data.token, 1);
          setCookie("Profile", JSON.stringify(response.data.data));
          localStorage.setItem("Profile", JSON.stringify(response.data.data));
          if (closeBtn == false) {
            history.push(`/dashboard`);
          } else {
            handleClose();
          }

          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: true,
          });
        } else if (response.data.success === false) {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: false,
          });
          appDispatch({ type: "logout", loggedIn: false });
        }
      } catch (e) {
        setLoading(false);
        handleError(e, appDispatch);
      }
    }
  };
  const handleSendOtp = async () => {
    setLoading(true);
    if (Purpose == "signUp") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}send/otp`,
          { mobile_no: `${phone.phoneCode}${phone.phoneNumber}` }
        );
        if (response.data.success === true) {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: true,
          });
          setOTP("");
        } else if (response.data.success === false) {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.data,
            alertSuccess: false,
          });
        }
        setSendAgain(false);
      } catch (e) {
        setLoading(false);
        handleError(e, appDispatch);

        setSendAgain(false);
      }
    } else if (Purpose == "signIn") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}check/mobile`,
          {
            mobile_no: `${phone.phoneCode}${phone.phoneNumber}`,
          }
        );
        if (response.data.success === true) {
          appDispatch({
            type: "setFieldValues",
            fieldValues: response.data.data.user_id,
          });
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: true,
          });
        } else if (response.data.success === false) {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: response.data.message,
            alertSuccess: false,
          });
        }
        setSendAgain(false);
      } catch (e) {
        setLoading(false);
        handleError(e, appDispatch);
        setSendAgain(false);
      }
    }
  };

  const handleChangeNumber = () => {
    if (Purpose == "signIn") {
      appDispatch({ type: "setOtpModal", otpModal: false });
      appDispatch({ type: "setLoginModal", loginModal: true });
    } else if (Purpose == "signUp") {
      appDispatch({ type: "setOtpModal", otpModal: false });
      appDispatch({ type: "setSignUpPhoneModal", signUpPhoneModal: true });
    }
  };
  useEffect(() => {
    if (!sendAgain && appState.otpModal) {
      var timeleft = 60;
      var downloadTimer = setInterval(function () {
        if (timeleft <= 0) {
          clearInterval(downloadTimer);
          setSendAgain(true);
        }
        setTimer(timeleft);
        timeleft -= 1;
      }, 1000);
    }
  }, [sendAgain]);

  useEffect(() => {
    setTimeout(() => setAlertMessage({ open: false }), 3000);
  }, [alertMessage.open]);
  return (
    <div>
      <SignupModal
        signUpForm={signUpForm}
        handleSignUpForm={handleSignUpForm}
        backDrop={backDrop}
      />
      <Dialog
        id="verifyModal"
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={appState.otpModal}
        BackdropProps={{ invisible: backDrop }}
      >
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <LoaderAnimation />
          </Backdrop>
        )}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alertMessage.open}
          className={
            alertMessage.alertSuccess ? "success-alert" : "danger-alert"
          }
        >
          {alertMessage.alertSuccess ? (
            <Alert severity="success">{alertMessage.message}</Alert>
          ) : (
            <Alert severity="error">{alertMessage.message}</Alert>
          )}
        </Snackbar>

        <DialogContent>
          <div
            className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}
            id="verifyPhoneNumberMain"
          >
            <div className="row ">
              <div className="col-md-12 d-flex justify-content-between classforPaddinglogo">
                <img src={vendorsConfig.APP_LOGO} alt={vendorsConfig.APP_NAME} width="80" />
              </div>
            </div>
            <h1
              className={`familyManrope800 mt-3 ${
                appState.langValue === "ar" ? "d-flex" : ""
              }`}
            >
              {t("form.verify-number")}
            </h1>
            <p
              className={`familyManrope600 loginTitle m-0 ${
                appState.langValue === "ar" ? "d-flex text-right" : ""
              }`}
            >
              {t("form.enter-code")} {phone.phoneCode}-{phone.phoneNumber}
            </p>
            <div
              className={`optMain mt-3 ${
                appState.langValue === "ar" ? "classforArabic" : ""
              }`}
            >
              {/* SIKANDAR OTP */}
              {/* <OtpInput
                value={otpValue}
                inputStyle={true}
                onChange={otpFunction}
                className={`${otpValue ? "otpValue" : ""} otpInput`}
                numInputs={5}
                isInputNum={true}
                hasErrored={true}
                shouldAutoFocus={true}
                placeholder={true}
                placeholder="_____"
              /> */}
              {/* SAjid work */}
              {/* <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                className={`${OTP ? "otpValue" : ""} otpInput`}
                OTPLength={5}
                otpType="number"
                disabled={false}
                placeholder="_____"
              /> */}

              <OtpInput
                value={OTP}
                inputStyle={true}
                onChange={setOTP}
                className={`${OTP ? "otpValue" : ""} otpInput`}
                numInputs={5}
                isInputNum={true}
                hasErrored={true}
                shouldAutoFocus={true}
                //  placeholder={true}
                placeholder={`_____`}
              />
            </div>

            <div className="row mt-2">
              <div className="col-12">
                <p className="familyManrope700 notRegisterMain m-0">
                  <span className="notRegister d-flex">
                    {t("form.did-not-recieve")}?
                    {sendAgain ? (
                      <p
                        onClick={handleSendOtp}
                        className="cursor-pointer px-1"
                      >
                        Send Again
                      </p>
                    ) : (
                      <p className="px-1"> {timer} sec </p>
                    )}
                    {/* <ResendOTP
                      className="d-flex flex-row-reverse"
                      renderButton={renderButton}
                      onResendClick={handleSendOtp}
                      maxTime={60}
                      t={t}
                    /> */}
                  </span>
                </p>
                <p
                  className={`familyManrope700 notRegisterMain mt-2 ${
                    appState.langValue === "ar" ? "d-flex" : ""
                  }`}
                >
                  <a
                    className="createAccountAndforgotPass"
                    onClick={handleChangeNumber}
                  >
                    {t("form.differ-number")}
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default withTranslation()(VerifyPhoneNumber);
